import { render, staticRenderFns } from "./unavailableTax.vue?vue&type=template&id=740fa0d6&scoped=true"
import script from "./unavailableTax.vue?vue&type=script&lang=js"
export * from "./unavailableTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740fa0d6",
  null
  
)

export default component.exports